import { Component, input, output, signal } from '@angular/core';
import { DsButtonModule, DsIconModule, DsLabelModule, DsModalModule } from '@bmw-ds/components';
import { TranslateModule } from '@ngx-translate/core';
import { MockedFile } from 'src/app/shared/models/backoffice/mocked-file.model';

@Component({
  selector: 'pure-preview-file-modal',
  imports: [DsModalModule, DsIconModule, TranslateModule, DsLabelModule, DsButtonModule],
  templateUrl: './preview-file-modal.component.html',
  styleUrl: './preview-file-modal.component.scss',
})
export class PreviewFileComponent {
  file = input.required<MockedFile>();
  closed = output<void>();

  modalIsOpen = signal<boolean>(true);

  protected readonly JSON = JSON;

  modalDismissed(): void {
    this.modalIsOpen.set(false);
  }
}
